import React, { useEffect, useState } from "react";
import Col from "react-bootstrap/Col";
import Modal from "react-bootstrap/Modal";
import Row from "react-bootstrap/Row";
// import { TextAreaField } from "../../../formElements/TextAreaField";

//API
import ItemService from "../../../../services/supplier_appCommonService";
import SuccessModal from "../../../../Components/Modal/supplier_app/SuccessModal";
import { TextAreaField } from "../../../../Components/formElements/TextAreaField";

const GrnCancelModal = React.forwardRef((props, ref) => {
  // const dispatch = useDispatch();
  const { type, selectedrow, title } = props;
  const [formInputs, setFormInputs] = useState({
    documentNumbers: [],
    statusHeader: "Cancel",
    cancellationRemark: "",
  });
  const [errorMsg, setErrorMsg] = useState("");

  useEffect(() => {
    setFormInputs((prevFormInputs) => ({
      ...prevFormInputs,
      documentNumbers: selectedrow?.map((item) => item?.documentNumber) || [],
    }));
  }, [selectedrow]);

  /* success modal */
  const successModalData = {
    title: "Message",
    successMsg: "",
  };
  const [getShowSuccessModal, setShowSuccessModal] = useState(false);
  const [getsucceModalData, setsucceModalData] = useState(successModalData);

  const onSuccessmodel = () => {
    setShowSuccessModal(true);
  };
  const hideSuccessModal = () => {
    setShowSuccessModal(false);
  };

  const handleSubmit = async () => {
  if (!formInputs?.cancellationRemark) {
    setErrorMsg("*Please enter the remarks");
    return;
  }

  let obj = {
    module: type, // make sure `type` is defined
    qualityCheckHeader: formInputs?.qualityCheckHeader,
    qualityCheckNr: formInputs?.qualityCheckNr,
    documentNumber: formInputs?.qualityCheckNr,
    status: "Cancelled",
    cancellationRemark: formInputs?.cancellationRemark,
  };

  console.log("Cancel Payload:", obj);

  try {
    const item = await ItemService.cancelGRN(obj);

    if (item?.status === 200) {
      successModalData.successMsg =
        item.message || "Cancelled Successfully";
      setsucceModalData(successModalData);
      onSuccessmodel();
      props.onHide(); // ✅ close AFTER success
    }
  } catch (err) {
    console.error("Cancel QC error", err);
  }
};


  const onInputChange = ({ target: { name, value } }) => {
    setFormInputs((formInputs) => ({ ...formInputs, [name]: value }));
  };

  return (
    <>
      <Modal
        {...props}
        aria-labelledby="contained-modal-title-vcenter"
        keyboard={false}
        size="lg"
        ref={ref}
        centered
      >
        <Modal.Header>
          <Modal.Title id="contained-modal-title-vcenter">
            <i className="bi bi-plus-lg"></i> {title}
            {/* <p className="subText">
          At supplier_app, every person has a role, each with its own level of
          access.
        </p> */}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="">
          <form className="space-y-4">
            <Row>
              <Col xs={12} md={12} lg={12} className="commLeftRightPadding">
                <div className="fw-medium mb-4">
                  <p> Do you want to cancel the {type} Number? </p>{" "}
                  <Row>
                    {formInputs?.documentNumbers.map((item, index) => (
                      <Col xs={5} lg={2} className="me-2" key={index}>
                        <p className="bg-table-status bg-table-new-status mb-1 px-2">
                          {item}
                        </p>
                      </Col>
                    ))}
                  </Row>
                </div>
                <TextAreaField
                  className="inputBox"
                  label=""
                  name="cancellationRemark"
                  placeholder={`Please enter the ${type} remark`}
                  value={formInputs.cancellationRemark}
                  onChange={onInputChange}
                />
              </Col>
            </Row>

            <Row className="justify-end">
              <Col xs={6} md={3} lg={3} className="commLeftRightPadding">
                <button
                  type="button"
                  onClick={() => props.onHide()}
                  className="btn btn-danger mt-4 w-full justify-center rounded-md"
                >
                  No
                </button>
              </Col>
              <Col xs={6} md={3} lg={3} className="commLeftRightPadding">
                <button
                  type="button"
                  onClick={handleSubmit}
                  className="btn btn-primary mt-4 w-full justify-center rounded-md"
                >
                  Yes
                </button>
              </Col>
              <Col xs={12} md={12} lg={12} className="commLeftRightPadding">
                <p className="errorMsg"> {errorMsg} </p>
              </Col>
            </Row>
          </form>
        </Modal.Body>
      </Modal>

      <SuccessModal
        show={getShowSuccessModal}
        onHide={() => hideSuccessModal()}
        successmodaldata={getsucceModalData}
      />
    </>
  );
});

export default GrnCancelModal;
